// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class ChatAutomationInactive {
  threshold?: number;
  messageHtml?: string;
}
